import { selector } from 'recoil';
import { determineOrderStatus } from '../../helpers/order-status.js';
import orderDetailsState from './order-details-state.js';
const orderDetailsStatusState = selector({
    key: 'orderDetailsStatus',
    get: ({ get }) => {
        const orderDetails = get(orderDetailsState.response);
        if (orderDetails && orderDetails.AdditionalOrderData?.RequiredData) {
            return determineOrderStatus({
                order: orderDetails.Result,
                productRequirements: orderDetails.AdditionalOrderData?.ProductRequirements ?? undefined,
                requiredData: orderDetails.AdditionalOrderData.RequiredData,
            });
        }
    },
});
export default orderDetailsStatusState;
//# sourceMappingURL=order-details-status-state.js.map